import React, { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface RoleGuardProps {
  requiredRole: string | string[];
  children: ReactNode;
  fallback: ReactNode;
}

export function RoleGuard({
  requiredRole,
  children,
  fallback,
}: RoleGuardProps): React.ReactElement {
  const { hasRole } = useAuth();

  const requiredRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
  const hasRequiredRole = requiredRoles.some((role) => hasRole(role));

  if (!hasRequiredRole && !hasRole('sophia_admin')) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
